import { User } from "../../models/User";
import { AsyncState } from "./AsyncState";

export class UserState extends AsyncState {
    currentUser: User | null = null;
    states: any[] = [];
}